import { useShortContentParams } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { VideoRecommendationsForLearningContent } from '../../recommendations';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentCompletedVideoView = ({
  shortId: shortIdProp,
  language: languageProp
}) => {
  const {
    shortId: shortIdParam,
    language: languageParam
  } = useShortContentParams();
  const shortId = shortIdProp || shortIdParam;
  const language = languageProp || languageParam;
  if (!shortId || !language) return null;
  return /*#__PURE__*/_jsx(VideoRecommendationsForLearningContent, {
    id: shortId,
    language: language,
    moreTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.shortContent.moreTitle"
    }),
    type: "SHORT_FORM_CONTENT"
  });
};
export default ShortContentCompletedVideoView;